import React from "react";

const StarRating = ({ editable = false, rating = 0, text, className }) => {
  if (editable) {
    return (
      <div className={`star-rating ${className}`}>
        <input type="radio" name="stars" id="star-a" value="5" />
        <label for="star-a"></label>

        <input type="radio" name="stars" id="star-b" value="4" />
        <label for="star-b"></label>

        <input type="radio" name="stars" id="star-c" value="3" />
        <label for="star-c"></label>

        <input type="radio" name="stars" id="star-d" value="2" />
        <label for="star-d"></label>

        <input type="radio" name="stars" id="star-e" value="1" />
        <label for="star-e"></label>
      </div>
    );
  } else {
    return (
      <div className="flex">
        <div className={`star-rating ${className}`}>
          <span
            className={`star ${rating <= 4 && "empty"} ${
              rating > 4.2 && rating < 4.7 && "half"
            } ${rating >= 4.7 && "full"}`}
          ></span>
          <span
            className={`star ${rating <= 3 && "empty"} ${
              rating > 3.2 && rating < 3.7 && "half"
            } ${rating >= 3.7 && "full"}`}
          ></span>
          <span
            className={`star ${rating <= 2 && "empty"} ${
              rating > 2.2 && rating < 2.7 && "half"
            } ${rating >= 2.7 && "full"}`}
          ></span>
          <span
            className={`star ${rating <= 1 && "empty"} ${
              rating > 1.2 && rating < 1.7 && "half"
            } ${rating >= 1.7 && "full"}`}
          ></span>
          <span
            className={`star ${rating <= 1 && "empty"} ${
              rating >= 1 && "full"
            }`}
          ></span>
        </div>
        {text && <span className="ml-2 text-gray-light">{text}</span>}
      </div>
    );
  }
};

export default StarRating;
